// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31pHR","content":"styles_content__2TLn0"};